import Room from "@models/building/Room";
import Unit from "@models/building/Unit";
import store from "@store";
import Accessorygroup from "@models/helpers/Accessorygroup";
import ArticlesHasAccessorygroup from "@models/helpers/ArticlesHasAccessorygroup";
import StoredRoomArticle from "@models/articles/StoredRoomArticle";
import StoredArticle from "@models/articles/StoredArticle";

export function setDeviceControll(unitId, articleType = 1) {
  const controllingCombo = JSON.parse(
    JSON.stringify(store.state.controllingCombo.controllingCombo)
  );
  const rooms = Room.query().where("unitId", unitId).get();
  const unit = Unit.query().where("id", unitId).first();

  const deviceCount = {
    primary: 0,
    secondary: 0,
  };

  let controllingComboIndex = 0;

  const exhaustRooms = [];
  const supplyRooms = {};
  const elsRooms = {};
  const ec45Rooms = {};

  // Loop through all rooms and check if they have a device with quantity >= 1 and articleId 727 (KWL 45)
  // If so, push the room to the exhaustRooms array if the airType is 1 (exhaust)
  // If the airType is 2 (supply), push the room to the supplyRooms array with the key being the storey and level
  rooms.forEach((room) => {
    const device = StoredRoomArticle.query()
      .whereId([727, room.id, 1])
      .where("quantity", (quantity) => quantity >= 1)
      .first();
    if (device == null || device == undefined) {
      room.controllingCombo = null;
      let accessorygroupArticles = ArticlesHasAccessorygroup.query()
        .where("accessorygroups_id", (id) => [42, 43, 44, 45].includes(id))
        .get();
      const els = StoredRoomArticle.query()
        .where("room_id", room.id)
        .where("accessorygroup_id", 1)
        .where("article_id", (id) =>
          accessorygroupArticles.some((article) => article.articles_id == id)
        )
        .where("quantity", (quantity) => quantity >= 1)
        .get();
      if (els.length > 0) {
        if (!elsRooms[room.storey]) {
          elsRooms[room.storey] = {};
        }
        if (!elsRooms[room.storey][room.level]) {
          elsRooms[room.storey][room.level] = [];
        }
        elsRooms[room.storey][room.level].push(room);
      }
      room.$save();
      return;
    }

    if (room.airType == 1) {
      exhaustRooms.push({
        id: room.id,
        quantity: device.quantity,
        storey: room.storey,
        level: room.level,
      });
      // check if ec45Room with same storey and level exists
      if (!ec45Rooms[room.storey]) {
        ec45Rooms[room.storey] = {};
        if (!ec45Rooms[room.storey][room.level]) {
          ec45Rooms[room.storey][room.level] = room.id;
        }
      }
    } else if (room.airType == 2) {
      const key = room.storey + "-" + room.level;
      if (!supplyRooms[key]) {
        supplyRooms[key] = [];
      }
      supplyRooms[key].push({
        id: room.id,
        quantity: device.quantity,
        storey: room.storey,
        level: room.level,
      });
      if (!ec45Rooms[room.storey]) {
        ec45Rooms[room.storey] = {};
      }
      ec45Rooms[room.storey][room.level] = room.id;
    } else {
      room.controllingCombo = null;
      room.$save();
      return;
    }
  });

  // Loop through all exhaust rooms
  // Set Room.controllingCombo to the value of the controllingCombo array at the index of controllingComboIndex
  // Count Device quantity and add to deviceCount
  exhaustRooms.forEach((room) => {
    Room.update({
      where: room.id,
      data: {controllingCombo: controllingCombo[controllingComboIndex].value},
    });
    if (articleType == 1) {
      concealedDeviceCount(deviceCount, room.quantity);
    } else {
      railDeviceCount(deviceCount, room.quantity);
    }
    controllingComboIndex++;
  });

  // Loop through all supply rooms
  // Set Room.controllingCombo to the value of the controllingCombo array at the index of controllingComboIndex
  // ControllingCombo can have a max of 16 devices
  // If room would exceed 16 devices, add 1 to the index and set the controllingCombo to the next value
  // Count total Device quantity of controllingCombo before it changes and add to deviceCount
  for (const key in supplyRooms) {
    let deviceQuantity = 0;

    if (supplyRooms.hasOwnProperty(key)) {
      supplyRooms[key].forEach((room) => {
        deviceQuantity += room.quantity;
        if (deviceQuantity > 16) {
          deviceQuantity -= room.quantity;
          controllingComboIndex++;
          if (articleType == 1) {
            concealedDeviceCount(deviceCount, deviceQuantity);
          } else {
            railDeviceCount(deviceCount, deviceQuantity);
          }
          deviceQuantity = room.quantity;
        }
        Room.update({
          where: room.id,
          data: {
            controllingCombo: controllingCombo[controllingComboIndex].value,
          },
        });
      });
      if (articleType == 1) {
        concealedDeviceCount(deviceCount, deviceQuantity);
      } else {
        railDeviceCount(deviceCount, deviceQuantity);
      }
      controllingComboIndex++;
    }
  }

  // set controllingCombo for all els rooms
  for (const elsStoreyKey in elsRooms) {
    for (const elsLevelKey in elsRooms[elsStoreyKey]) {
      let roomId = null;
      // check if ec45Room with same storey and level exists
      if (ec45Rooms[elsStoreyKey] && ec45Rooms[elsStoreyKey][elsLevelKey]) {
        roomId = ec45Rooms[elsStoreyKey][elsLevelKey];
      }
      if (roomId === null) {
        // find ec45Room with smallest storey difference
        let smallestStoreyDifference = null;
        let nearestStorey = null;
        for (const ec45StoreyKey in ec45Rooms) {
          if (ec45Rooms.hasOwnProperty(ec45StoreyKey)) {
            const storeyDifference = Math.abs(ec45StoreyKey - elsStoreyKey);
            if (
              smallestStoreyDifference === null ||
              storeyDifference < smallestStoreyDifference
            ) {
              smallestStoreyDifference = storeyDifference;
              nearestStorey = ec45StoreyKey;
            }
          }
        }
        // find ec45Room[nearestStorey] with smallest level difference
        let smallestLevelDifference = null;
        for (const ec45LevelKey in ec45Rooms[nearestStorey]) {
          if (ec45Rooms[nearestStorey].hasOwnProperty(ec45LevelKey)) {
            const levelDifference = Math.abs(ec45LevelKey - elsLevelKey);
            if (
              smallestLevelDifference === null ||
              levelDifference < smallestLevelDifference
            ) {
              smallestLevelDifference = levelDifference;
              roomId = ec45Rooms[nearestStorey][ec45LevelKey];
            }
          }
        }
      }
      if (roomId === null) {
        continue;
      }
      // get controllingCombo of ec45Room
      const controllingCombo = Room.query()
        .whereId(roomId)
        .first().controllingCombo;
      // set controllingCombo of elsRooms
      elsRooms[elsStoreyKey][elsLevelKey].forEach((room) => {
        Room.update({
          where: room.id,
          data: {controllingCombo: controllingCombo},
        });
      });
    }
  }

  updateControllingArticles(unitId, deviceCount, articleType);
}

function updateControllingArticles(unitId, deviceCount, articleType = 1) {
  // Get Accessorygroups with ParentId 35 (KWL 45 Controlling)
  const accessorygroups = Accessorygroup.query()
    .where("parent_group_id", 35)
    .orderBy("sort_index", "asc")
    .get();

  // Loop through all accessorygroups and delete store entries
  accessorygroups.forEach((accessorygroup) => {
    //
    StoredArticle.delete((article) => {
      return (
        article.unit_id == unitId &&
        article.accessorygroup_id == accessorygroup.id
      );
    });
  });

  if (articleType == 1) {
    // find article 329 and 331 in store if not found create new store entry
    let primaryArticle = StoredArticle.query()
      .where("unit_id", unitId)
      .where("accessorygroup_id", 59)
      .where("article_id", 329)
      .first();
    if (!primaryArticle) {
      primaryArticle = new StoredArticle();
      primaryArticle.unit_id = unitId;
      primaryArticle.accessorygroup_id = 59;
      primaryArticle.article_id = 329;
    }
    let secondaryArticle = StoredArticle.query()
      .where("unit_id", unitId)
      .where("accessorygroup_id", 59)
      .where("article_id", 331)
      .first();
    if (!secondaryArticle) {
      secondaryArticle = new StoredArticle();
      secondaryArticle.unit_id = unitId;
      secondaryArticle.accessorygroup_id = 59;
      secondaryArticle.article_id = 331;
    }
    primaryArticle.quantity = deviceCount.primary;
    secondaryArticle.quantity = deviceCount.secondary;
    primaryArticle.$save();
    secondaryArticle.$save();
  } else {
    let primaryArticle = StoredArticle.query()
      .where("unit_id", unitId)
      .where("accessorygroup_id", 59)
      .where("article_id", 330)
      .first();
    if (!primaryArticle) {
      primaryArticle = new StoredArticle();
      primaryArticle.unit_id = unitId;
      primaryArticle.accessorygroup_id = 59;
      primaryArticle.article_id = 329;
    }
    let secondaryArticle = StoredArticle.query()
      .where("unit_id", unitId)
      .where("accessorygroup_id", 59)
      .where("article_id", 326)
      .first();
    if (!secondaryArticle) {
      secondaryArticle = new StoredArticle();
      secondaryArticle.unit_id = unitId;
      secondaryArticle.accessorygroup_id = 59;
      secondaryArticle.article_id = 331;
    }

    primaryArticle.quantity = deviceCount.primary;
    secondaryArticle.quantity = deviceCount.secondary;
    primaryArticle.$save();
    secondaryArticle.$save();
  }

  // Add controllingCombo to storedControllingCombo with unitId as key
  store.dispatch("controllingCombo/addControllingCombo", {
    unitId: unitId,
    controllingCombo: deviceCount,
  });
}

function concealedDeviceCount(deviceCount, quantity) {
  // If quantity <= 6, add 1 to primary
  // If quantity = 7 || 8 add 1 to primary and 1 to secondary
  // If 8 < quantity <= 12 add 2 to primary
  // If quantity = 13 || 14 add 2 to primary and 1 to secondary
  // If quantity = 15 || 16 add 2 to primary and 2 to secondary
  if (quantity <= 6) {
    deviceCount.primary += 1;
  } else if (quantity == 7 || quantity == 8) {
    deviceCount.primary += 1;
    deviceCount.secondary += 1;
  } else if (quantity > 8 && quantity <= 12) {
    deviceCount.primary += 2;
  } else if (quantity == 13 || quantity == 14) {
    deviceCount.primary += 2;
    deviceCount.secondary += 1;
  } else {
    deviceCount.primary += 2;
    deviceCount.secondary += 2;
  }
}

function railDeviceCount(deviceCount, quantity) {
  // If quantity <= 4, add 1 to primary
  // If quantity > 4 <= 8 add 1 to primary and 1 to secondary
  // If quantity > 8 <= 12 add 2 to primary and 1 to secondary
  // If quantity > 12 <= 16 add 2 to primary and 2 to secondary
  if (quantity <= 4) {
    deviceCount.primary += 1;
  } else if (quantity > 4 && quantity <= 8) {
    deviceCount.primary += 1;
    deviceCount.secondary += 1;
  } else if (quantity > 8 && quantity <= 12) {
    deviceCount.primary += 2;
    deviceCount.secondary += 1;
  } else {
    deviceCount.primary += 2;
    deviceCount.secondary += 2;
  }
}

export function checkDeviceControll(roomId, newControllingCombo) {
  const room = Room.query().whereId(roomId).first();
  const device = StoredRoomArticle.query()
    .whereId([727, room.id, 1])
    .where("quantity", (quantity) => quantity >= 1)
    .first();

  // if no ec 45 device
  if (!device) {
    // then only existing controllingCombo is allowed
    return Room.query()
      .where("unitId", room.unitId)
      .where("controllingCombo", newControllingCombo)
      .exists();
  }

  // Get all rooms of unit with ec 45 device
  const rooms = Room.query()
    .where("unitId", room.unitId)
    .whereHas("articles", (storedRoomArticle) => {
      storedRoomArticle
        .where("article_id", 727)
        .where("quantity", (quantity) => quantity >= 1);
    })
    .with("articles", (storedRoomArticle) => {
      storedRoomArticle
        .where("article_id", 727)
        .where("quantity", (quantity) => quantity >= 1);
    })
    .get();

  const deviceCount = {
    primary: 0,
    secondary: 0,
  };
  const controllingCombo = {};
  // Loop through all rooms and add device quantity to controllingCombo {a: 1, B: 4, ...}
  rooms.forEach((room) => {
    // check if room is changed room
    if (room.id == roomId) {
      room.controllingCombo = newControllingCombo;
    }
    if (controllingCombo[room.controllingCombo] == undefined) {
      controllingCombo[room.controllingCombo] = 0;
    }
    controllingCombo[room.controllingCombo] += room.articles[0].quantity;
  });

  // go through all controllingCombos and add device quantity to deviceCount
  for (const key in controllingCombo) {
    if (!controllingCombo.hasOwnProperty(key)) {
      continue;
    }
    concealedDeviceCount(deviceCount, controllingCombo[key]);
  }
  updateControllingArticles(room.unitId, deviceCount);
  store.state.controllingCombo.controllingCombo_index += 1;
  return true;
}

/**
 * @return boolean
 * @param {int} unitId
 *
 * Check if Rooms in Unit has no ControllingCombo
 *
 * If Rooms has no ControllingCombo, return false
 * Else check how many ec45, els or m1 devices are in the rooms per controllingCombo
 * set controllingCombo in store and return true
 */
export function checkControllingCombo(unitId, articleId) {
  const rooms = Room.query().where("unitId", unitId).get();
  const controllingCombo = {};
  rooms.forEach((room) => {
    // check if room has controllingCombo
    if (room.controllingCombo == null || room.controllingCombo === "") {
      return false;
    }

    // get devices in room
    const ec45 = StoredRoomArticle.query()
      .whereIdIn([[727, room.id, 1]])
      .where("quantity", (quantity) => quantity >= 1)
      .get();
    if (ec45.length > 0) {
      ec45.forEach((device) => {
        if (controllingCombo[room.controllingCombo] == undefined) {
          controllingCombo[room.controllingCombo] = 0;
        }
        controllingCombo[room.controllingCombo] += device.quantity;
      });
    }
  });
  const deviceCount = {
    primary: 0,
    secondary: 0,
  };
  for (const key in controllingCombo) {
    if (!controllingCombo.hasOwnProperty(key)) {
      continue;
    }
    if (articleId == 329 || articleId == 331) {
      concealedDeviceCount(deviceCount, controllingCombo[key]);
    } else {
      railDeviceCount(deviceCount, controllingCombo[key]);
    }
  }
  store.dispatch("controllingCombo/addControllingCombo", {
    unitId: unitId,
    controllingCombo: deviceCount,
  });
  return true;
}
